import { useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AppContext } from '../context/AppContext';

export const SCHeader = ({ backToScientificCommitee = undefined, section = undefined }: { backToScientificCommitee?: string, section?: string }) => {
  const appContext = useContext(AppContext);
  const scientific_committee = appContext?.state.data?.scientific_committee;

  const imageSrc = `${process.env.REACT_APP_ASSETS_PATH}/images/logos/sc-logo.jpg`;
  const title = scientific_committee?.name || 'ICOH Scientific Committee';

  if (!scientific_committee) return null;

  return (
    <header>
      <Container>
        <Row className="align-items-center my-3">
          <Col xs="auto">
            <img
              src={imageSrc}
              className="d-inline-block align-top"
              alt={title}
              height={100}
            />
          </Col>
          <Col>
            <h1 className="site-name">{title}</h1>
          </Col>
        </Row>
      </Container>
    </header>
  );
};